module.exports = __webpack_public_path__ + "static/img/list-2.ffe12a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/list-2.png
// module id = J+2x
// module chunks = 1